import { render, staticRenderFns } from "./OrderNew2.vue?vue&type=template&id=6f7e794a&scoped=true&"
import script from "./OrderNew2.vue?vue&type=script&lang=js&"
export * from "./OrderNew2.vue?vue&type=script&lang=js&"
import style0 from "./OrderNew2.vue?vue&type=style&index=0&id=6f7e794a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7e794a",
  null
  
)

export default component.exports